import React, { useState } from 'react';
import collegeConfig from '../../config/collegeConfig';
import { FaUpload, FaTimesCircle, FaSpinner, FaFilePdf, FaFileImage } from 'react-icons/fa';

const API = collegeConfig.api.baseURL;
const MAX_CERT_SIZE = 8 * 1024 * 1024; // 8 MB — enforced by multer on the server

// Picks a file, compresses images client-side, uploads to B2 via /api/upload/attachment,
// then hands { fileKey, fileName, mimeType } back to the parent to persist wherever it needs.
const CertUploadWidget = ({ onUpload, uploading, inputId, label }) => {
  const [file, setFile] = useState(null);
  const [b2Loading, setB2Loading] = useState(false);

  const handleFileChange = (e) => {
    const f = e.target.files[0];
    if (!f) return;
    if (f.size > MAX_CERT_SIZE) { alert('File must be under 8 MB'); e.target.value = ''; return; }
    if (!['image/jpeg', 'image/png', 'application/pdf'].includes(f.type)) {
      alert('Only JPG, PNG, or PDF files are allowed'); e.target.value = ''; return;
    }
    setFile(f);
  };

  const doUpload = async () => {
    if (!file) return;
    setB2Loading(true);
    try {
      const token = localStorage.getItem('token');
      let uploadFile = file;
      if (file.type.startsWith('image/')) {
        try {
          const imageCompression = (await import('browser-image-compression')).default;
          uploadFile = await imageCompression(file, { maxSizeMB: 1, maxWidthOrHeight: 1920, useWebWorker: true });
        } catch { /* fallback to original */ }
      }
      const formData = new FormData();
      formData.append('file', uploadFile, file.name);
      const res = await fetch(`${API}/upload/attachment`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
        body: formData
      });
      const data = await res.json();
      if (!data.success) { alert(data.message || 'Upload failed'); return; }
      onUpload({ fileKey: data.attachment.key, fileName: data.attachment.name, mimeType: file.type });
      setFile(null);
    } catch { alert('Upload failed. Please try again.'); }
    finally { setB2Loading(false); }
  };

  const busy = b2Loading || uploading;

  return (
    <div style={{ marginTop: 10 }}>
      <input type="file" id={inputId} accept=".pdf,.jpg,.jpeg,.png" onChange={handleFileChange} style={{ display: 'none' }} />
      {!file ? (
        <label htmlFor={inputId} style={s.uploadLabel}>
          <FaUpload style={{ marginRight: 6 }} />
          {label || 'Choose Certificate (JPG / PNG / PDF, max 8 MB)'}
        </label>
      ) : (
        <div style={s.fileRow}>
          {file.type === 'application/pdf'
            ? <FaFilePdf style={{ color: '#dc2626', fontSize: 20, flexShrink: 0 }} />
            : <FaFileImage style={{ color: '#2563eb', fontSize: 20, flexShrink: 0 }} />}
          <span style={{ flex: 1, fontSize: 13, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{file.name}</span>
          <span style={{ fontSize: 12, color: '#666', whiteSpace: 'nowrap' }}>{(file.size / 1024).toFixed(0)} KB</span>
          <button onClick={doUpload} disabled={busy} style={s.uploadBtn}>
            {busy ? <FaSpinner className="stucert-spinner-sm" style={{ marginRight: 4 }} /> : <FaUpload style={{ marginRight: 4 }} />}
            {b2Loading ? 'Uploading…' : uploading ? 'Saving…' : 'Upload'}
          </button>
          <button onClick={() => setFile(null)} disabled={busy} style={s.iconBtn}><FaTimesCircle /></button>
        </div>
      )}
    </div>
  );
};

const s = {
  uploadLabel: { display: 'inline-flex', alignItems: 'center', padding: '8px 16px', border: '1px dashed #b11217', color: '#b11217', borderRadius: 8, cursor: 'pointer', fontSize: 13, fontWeight: 600, background: '#fff' },
  fileRow: { display: 'flex', alignItems: 'center', gap: 8, padding: '10px 12px', background: '#f0fdf4', border: '1px solid #a7f3d0', borderRadius: 8 },
  uploadBtn: { background: '#b11217', color: '#fff', border: 'none', borderRadius: 8, padding: '6px 14px', cursor: 'pointer', fontWeight: 600, fontSize: 12, display: 'flex', alignItems: 'center', flexShrink: 0 },
  iconBtn: { background: 'none', border: 'none', cursor: 'pointer', color: '#666', padding: 4, fontSize: 16 }
};

export default CertUploadWidget;
